
import {Prop} from 'vue-property-decorator'
import Vue from 'vue'
import Component from 'vue-class-component'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import BlueButton from '@/components/Atomic/BlueButton.vue'
import RedButton from '@/components/Atomic/RedButton.vue'
import GreenButton from '@/components/Atomic/GreenButton.vue'
import { OrganisationJobTitle } from '@/models/organisationJobTitle'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import INotificationService from '@/services/NotificationService'
import OrganisationsService from '@/services/OrganisationsService'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    CardTitle,
    BlueButton,
    RedButton,
    GreenButton,
    ProgressLinear,
  },
})

export default class CreateJobTitles extends Vue {
  @Prop() public readonly jobTitles!: OrganisationJobTitle[]
  @Prop(Function) public readonly onDialogClose!: () => void

  private errorHandlerService: ErrorHandlerService
  private $notificationService!: INotificationService

  private jobTitle: string = ''
  private forGuest: boolean = false
  private jobTitleDialog: boolean = false
  private isPending: boolean = false

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  private show() {
    this.jobTitle = ''
  }

  private mounted() {
    this.jobTitle = ''
  }

  private resetDialog() {
    this.jobTitleDialog = false
    this.jobTitle = ''
  }

  private async create() {
    if (this.jobTitle === '') {
      return
    }
    this.isPending = true
    try {
      await OrganisationsService.createJobTitle(this.jobTitle, this.forGuest)
      this.$notificationService.success(this.$t('EXTRAS.JobTitleCreated').toString() + ' : ' + this.jobTitle)
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.jobTitle = ''
    this.isPending = false
    this.onDialogClose()
    this.jobTitleDialog = false
  }
}
